import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { TcAccordionModule } from '../tc-accordion/tc-accordion.module';
import { TCAcceptIsValidatedGuard } from './guards/tc-accept-validated-guard';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';

@NgModule({
  declarations: [TermsAndConditionsComponent],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatButtonModule,
    TcAccordionModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoContentComponent: {
          component: TermsAndConditionsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [TCAcceptIsValidatedGuard],
        },
      },
    } as CmsConfig),
  ],
  exports: [TermsAndConditionsComponent],
  // providers: [{ provide: TermsAndConditionsComponent }],
})
export class TermsAndConditionsModule {}
